import { put, takeEvery, takeLatest } from "redux-saga/effects";
import { keHoachTapTapApi } from "../../../api/xet-thuc-tap/keHoachThucTapApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eKeHoachThucTapActionIds, IKeHoachThucTapActionTypes } from "../../action-types/xet-thuc-tap/IKeHoachThucTapActions";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { IKeHoachThucTap } from "../../../model/response/xet-thuc-tap/IKeHoachThucTap";
import { IKeHoachThucTapUpdateTrangThaiRequest } from "../../../model/request/xet-thuc-tap/IKeHoachThucTapUpdateTrangThaiRequest";


export function* keHoachThucTapSaga(): any {
    yield takeLatest(eKeHoachThucTapActionIds.LOAD_START, loadWorker);
    yield takeEvery(eKeHoachThucTapActionIds.SAVE_START, saveWorker);
    yield takeEvery(eKeHoachThucTapActionIds.DELETE_START, deleteWorker);
    yield takeEvery(eKeHoachThucTapActionIds.UPDATE_ACTIVE_START, updateActiveWorker);
}


function* loadWorker(): any {
    const response: IBaseResponse = yield keHoachTapTapApi.SelectAll();
    console.log("🚀 ~ loadWorker ~ response:", response)
    if (response.is_success) {
        yield put(rootActions.xetThucTap.keHoachThucTap.LOAD_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.xetThucTap.keHoachThucTap.LOAD_ERROR(response.message ?? "Lỗi khi tải kế hoạch thực tập"));
    }
}

function* saveWorker(action: IKeHoachThucTapActionTypes) : any {
    const data = action.payload as IKeHoachThucTap;
    let response: IBaseResponse;
    if (data.id_dot_thuc_tap > 0) {
        response = yield keHoachTapTapApi.Update(data.id_dot_thuc_tap, data);
    }
    else {
        response = yield keHoachTapTapApi.Insert(data);
    }
    if (response.is_success) {
        yield put(rootActions.xetThucTap.keHoachThucTap.SAVE_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.xetThucTap.keHoachThucTap.SAVE_ERROR(response.message ?? "Lỗi khi lưu kế hoạch thực tập"));
    }
}

function* deleteWorker(action: IKeHoachThucTapActionTypes) {
    const id = action.payload as number;
    const response: IBaseResponse = yield keHoachTapTapApi.Delete(id);
    if (response.is_success) {
        yield put(rootActions.xetThucTap.keHoachThucTap.DELETE_SUCCESS(undefined));
    } else {
        yield put(rootActions.xetThucTap.keHoachThucTap.DELETE_ERROR(response.message ?? "Lỗi khi xóa kế hoạch thực tập"));
    }
}

function* updateActiveWorker(action: IKeHoachThucTapActionTypes) {
    const request =  action.payload as IKeHoachThucTapUpdateTrangThaiRequest;
    const response: IBaseResponse = yield keHoachTapTapApi.UpdateActive(request);
    if (response.is_success) {
        yield put(rootActions.xetThucTap.keHoachThucTap.UPDATE_ACTIVE_SUCCESS(undefined));
    } else {
        yield put(rootActions.xetThucTap.keHoachThucTap.UPDATE_ACTIVE_ERROR(response.message ?? "Lỗi khi cập nhật trạng thái kế hoạch thực tập"));
    }
}